module.exports = __webpack_public_path__ + "img/14.b5251ea7.svg";